// This util function has a plcace in the codebase due to IE10's lack of support
// on the second argument (force) on the native classList.toggle implementation

/**
 * Toggles the given class on a given element
 * @param {Element} element
 * @param {String} className
 * @param {Boolean} toggle
 */
const toggleClass = (element, className, toggle) => {
  element.classList[toggle ? 'add' : 'remove'](className);
};

export default toggleClass;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/toggleClass.js